import Vue from 'vue'
import Vuex from 'vuex'

// Module imports
import { alert } from './modules/alert.module'
import { decision } from './modules/decision.module'
import { swiftuser } from './modules/swiftuser.module'
import { questions } from './modules/questions.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    alert,
    decision,
    questions,
    swiftuser
  }
})
